import { useEffect, useState, useRef } from "react";
import { getAdditionalPoints } from "../_request";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import MDBadge from "components/MDBadge";
import { ADDITIONAL_POINTS_BADGES } from "../../../core/constant";
import MDBox from "components/MDBox";
import { formatDateInTimezone } from "../../../core/utils/formatDate";
import formatNumberWithCommas from "../../../core/utils/formatNumberWithCommas";

export default function data(setLoader, setAdditionalPointsForMobile) {
  const [additionalPointsData, setAdditionalPointsData] = useState([]);
  const isInitialRender = useRef(true);
  const getAdditionalPointsData = async () => {
    try {
      setLoader(true);
      const {
        data: { success, data },
      } = await getAdditionalPoints();
      if (success) {
        setAdditionalPointsData(data.customerAdditionalPoints);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };
  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    getAdditionalPointsData();
  }, []);

  useEffect(() => {
    const debounceTimeout = setTimeout(async () => {
      getAdditionalPointsData();
    }, 1000);
    return () => clearTimeout(debounceTimeout);
  }, []);

  useEffect(() => {
    const allAdditionalPointsData = additionalPointsData.map((data) => {
      return {
        id: data.id,
        restaurantName: data["_restaurant_store_restaurant_store.name"],
        processedDate: data.processedAt && formatDateInTimezone(data.processedAt, null, "long"),
        cashbackPoints: data.cashbackPoints,
        reason: data.reason,
        status: data.status,
        cashbackStatus: data.cashbackStatus,
      };
    });
    setAdditionalPointsForMobile(allAdditionalPointsData);
  }, [additionalPointsData]);
  return {
    columns: [
      { Header: "RESTAURANT NAME", accessor: "restaurantName", width: "20%", align: "left" },
      { Header: "PROCESSED DATE", accessor: "processedDate", align: "center" },
      { Header: "CASHBACK POINTS", accessor: "cashbackPoints", align: "center" },
      { Header: "STATUS", accessor: "status", align: "center" },
      { Header: "REASON", accessor: "reason", align: "center" },
    ],

    rows: additionalPointsData?.map((data) => {
      return {
        restaurantName: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data["_restaurant_store_restaurant_store.name"]
              ? data["_restaurant_store_restaurant_store.name"]
              : "-"}
          </MDTypography>
        ),
        processedDate: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data.processedAt ? formatDateInTimezone(data.processedAt, null, "long") : "-"}
          </MDTypography>
        ),
        cashbackPoints: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data.cashbackPoints ? formatNumberWithCommas(data.cashbackPoints) : 0}
          </MDTypography>
        ),
        status: data.status ? (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={data.status}
              color={ADDITIONAL_POINTS_BADGES[data.cashbackStatus]}
              variant="gradient"
              size="lg"
            />
          </MDBox>
        ) : (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {"-"}
          </MDTypography>
        ),
        reason: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data.reason ? data.reason : "NA"}
          </MDTypography>
        ),
      };
    }),
  };
}
data.prototype = {
  setLoader: PropTypes.func,
  setAdditionalPointsForMobile: PropTypes.any,
};
